export default __webpack_public_path__ + "static/media/WEEE.9c4ce6a5.svg";